export default "__VITE_ASSET__DAC5Gf3K__"